import { useQuery } from "@apollo/client";
import GET_LANGUAGE_DETAILS from "graphql/queries/GetLanguageDetails";
import { languageDataVar } from "cache";

const useBannerBackground = () => {
  const { data: languageDetails, refetch: refetchBannerBackground } = useQuery(
    GET_LANGUAGE_DETAILS,
    {
      variables: {
        id: languageDataVar().studyLanguageId,
      },
    }
  );

  const {
    languageDetails: { bannerBackground: bannerBackgroundUrl = "" } = {},
  } = languageDetails || {};

  const backgroundImage = bannerBackgroundUrl
    ? {
        backgroundImage: `url(${bannerBackgroundUrl})`,
        backgroundRepeat: "repeat",
      }
    : {};

  return {
    backgroundImage,
    refetchBannerBackground,
    bannerBackgroundUrl,
  };
};

export default useBannerBackground;
